import files from './modules/files';
import jobReviews from './modules/job-reviews';
import jobs from './modules/jobs';
import messages from './modules/messages';

export default {
  namespaced: true,
  modules: {
    files,
    jobReviews,
    jobs,
    messages,
  },
};
